module.exports = __webpack_public_path__ + "img/info-black.9621fc4a.svg";